import * as React from 'react'


import config from '../../constants/config'
import { Form, Image } from 'react-bootstrap'
import styleRules from '../../utils/styleRules'
import images from '../../constants/images'
import { UserT } from '../../types/Users'
import InputAutoComplete from '../InputAutoComplete/InputAutoComplete'
import { AxiosInstance } from '../../utils/RequestMethods'
declare const { defaultValue, value, ...inputAttributes }: React.InputHTMLAttributes<HTMLInputElement>;
type InputAttributes = typeof inputAttributes;
const keyGenerator = () => (
    Math.random().toString(36).substr(2, 10)
);

const UserObj = {
    id: null,
    address: '',
    address2: '',
    billingContact: null,
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    profilePic: '',
}

export interface IInputSearchUsersProps extends InputAttributes {
    textValue?: string
    onSelectUser?(user: UserT): void
    isShow?: boolean
    query?: {
        roles?: Array<string>
    }
    onChange?(event: any): void
    className?: string
    style?: any
    placeholder?: string
}

const InputSearchUsers: React.FC<IInputSearchUsersProps> = (props) => {
    const [textValue, setTextValue] = React.useState('')
    const [itemSelected, setItemSelected] = React.useState(false)
    const [isSearched, setIsSearched] = React.useState(false)

    React.useEffect(() => {

        if (props.textValue != textValue) {
            setTextValue(props.textValue)
        }
    }, [props.textValue])

    /**
     *
     * @param search
     * @returns
     */
    const searchUsers = async (search) => {
        let params = {
            'search': search,

        }
        if (props.query && props.query.roles) {
            params['roles'] = props.query.roles
        }
        let options={
          data:params
        }
        return AxiosInstance.get(`${config.url.users}`,options).then((res) => {
            if (res && res.data) {
                return res.data;
            }
            return []
        })
    }
    /**
     *
     * @param row
     */
    const onSelectUser = (row) => {

        setTextValue(row.place_name)
        // hide list display
        stopSearching();

        setItemSelected(row)

        if (props.onSelectUser) {
            const user = { ...UserObj, ...row }
            setTextValue(`${user.firstName} ${user.lastName}`)
            props.onSelectUser(user)
        }
    }

    /**
     *
     */
    const stopSearching = () => {
        setIsSearched(!isSearched)
    }

    /**
     *
     * @param row
     * @param index
     * @returns
     */
    const renderRowSearch = (row, index) => {
        return (
            <div key={index + "" + keyGenerator()} className="cursor" style={{ padding: 5 }}>
                <span className="" style={{
                    // padding: 5,
                    // margin: 5,
                    borderBottomColor: "#eee", borderBottomWidth: 1
                }}
                    // type={"button"}
                    onClick={() => onSelectUser(row)}>
                    <div>
                        <Image roundedCircle
                            style={{ width: 60, height: 60 }}
                            src={row.profilePic ? row.profilePic : images.noProfilePic}
                        //     alt={`${row.meta.first_name}
                        //    ${row.meta.last_name}`}
                        />
                        <span style={{ marginLeft: 5 }}>
                            {row.firstName ? row.firstName : ''} {row.lastName ? row.lastName : ''}
                        </span>

                    </div>
                </span>
            </div >

        )
    }
    return (

        // <Form.Group>

        <InputAutoComplete
            className={props.className}

            style={styleRules({ ...{ margin: 5 }, ...props.style })}
            editable={!props.isShow}
            searchData={searchUsers}
            textValue={`${textValue}`}
            onChange={props.onChange}
            onChangeText={(text) => {
                setTextValue(text)
            }}
            renderRow={renderRowSearch}
            // menuPortal={{
            //     menuPlacement:"bottom",
            //     menuPosition:"absolute"
            // }}
            // renderRows={renderItemsSearch}
            stopSearching={isSearched}
        // placeholder={props.placeholder}
        />

        // </Form.Group>
    )
}

InputSearchUsers.defaultProps = {
    className: "input-material m-2",
    style: null,
    placeholder: '',
    isShow: false,
}

export default InputSearchUsers
export { InputSearchUsers }
